import React, { useEffect } from "react";
import { ColorSchemeProvider, MantineProvider } from "@mantine/core";
import { ScreenContextProvider } from "./api/screenContext";
import { MantineTheme } from "./util/Theme";
import AppWrapper from "./components/AppWrapper";
import { useLocalStorage } from "@mantine/hooks";

function App() {
  const [colorScheme, setColorScheme] = useLocalStorage({
    key: "brain-color-scheme",
    defaultValue: "light",
    getInitialValueInEffect: true,
  });

  const toggleColorScheme = (value) =>
    setColorScheme(value || (colorScheme === "dark" ? "light" : "dark"));

  return (
    <ColorSchemeProvider
      colorScheme={colorScheme}
      toggleColorScheme={toggleColorScheme}
    >
      <MantineProvider
        withGlobalStyles
        withNormalizeCSS
        theme={{ ...MantineTheme, colorScheme: colorScheme || "dark" }}
      >
        <ScreenContextProvider>
          <AppWrapper />
        </ScreenContextProvider>
      </MantineProvider>
    </ColorSchemeProvider>
  );
}

export default App;
